import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['company']),
    isAdminMode () {
      return this.$route.name.startsWith('admin')
    },
    theme () {
      if (this.isAdminMode) {
        return this.company.theme.adminContainer
      } else if (this.$mq === 'mobile') {
        return this.company.theme.mobileContainer
      } else {
        return this.company.theme.userContainer
      }
    }
  },
  methods: {
    themeClasses (key) {
      // console.log('--------------------key', key, this.theme)
      if (this.theme.extraClass && this.theme.extraClass.hasOwnProperty(key)) {
        return this.theme.extraClass[key]
      }
      return ''
    }
  }
}
